<template>
	<div class="modifyPhone">
		<van-nav-bar class="nav_bar" :title="userphone ? '更换安全手机' : '绑定安全手机'" left-arrow placeholder @click-left="$router.back()" />
		<!-- 更换绑定 -->
		<div v-if="userphone" class="toModify">
			<div class="progress" v-if="modifyPhoneStep != 3">
				<div class="outer-1" :class="{ active: modifyPhoneStep >= 1 }">
					<div class="inner">1</div>
					<span class="txt">验证身份</span>
				</div>
				<div class="outer-2" :class="{ active: modifyPhoneStep >= 2 }">
					<div class="inner">2</div>
					<span class="txt">修改手机号码</span>
				</div>
				<div class="outer-3" :class="{ active: modifyPhoneStep == 3 }">
					<div class="inner">3</div>
					<span class="txt">完成更换</span>
				</div>
			</div>
			<div class="form">
				<template v-if="modifyPhoneStep == 1">
					<div class="desc">
						<p class="desc1">
							已绑定的手机：<span style="color:#1972FF;">{{ userphone }}</span>
						</p>
                        <p class="desc2">若该手机号已无法使用，请点击<span class="face" @click="handleFaceRecognition">人脸识别</span>验证身份</p>
                        <p class="desc2">（注：实名认证后才能人脸识别验证身份）</p>
					</div>
					<div class="inputWrapper authcodeInputWrapper">
						<van-field v-model="phoneCode" class="inputItem authcodeInput" clearable placeholder="请输入验证码" :border="false" />
						<div
							class="getVerificationStyle fr"
							@click="postAccountGetAuthCode('oldphone')"
							:style="{ color: Countdown > 0 ? '#BBBBBB' : '#333333' }"
						>
							{{ VerificationStatus }}
						</div>
					</div>
				</template>
				<template v-if="modifyPhoneStep == 2">
					<div class="inputWrapper phoneInput">
						<van-field v-model="modifyAccount.account" class="inputItem" center clearable :border="false" placeholder="请输入新手机号" />
					</div>
					<div class="inputWrapper authcodeInputWrapper">
						<van-field
							v-model="modifyAccount.authCode"
							class="inputItem authcodeInput"
							center
							clearable
							placeholder="请输入验证码"
							:border="false"
						/>
						<div
							class="getVerificationStyle fr"
							@click="postAccountGetAuthCode('newphone')"
							:style="{ color: Countdown > 0 ? '#BBBBBB' : '#333333' }"
						>
							{{ VerificationStatus }}
						</div>
					</div>
				</template>
				<template v-if="modifyPhoneStep == 3">
					<div class="modifySuccess">
                        <div class="img"></div>
						<div class="success_title">手机号更换成功</div>
						<div class="success_tip">请在下次使用新的手机号码进行登录</div>
						<div class="success_btn" @click="$router.back()">返回</div>
					</div>
				</template>
				<div class="OperatingSpace" v-if="modifyPhoneStep != 3">
					<van-button
						round
						type="info"
						:class="modifyPhoneBtnColor ? 'noneVanButton' : 'van-button--info'"
						@click="handleModifyPhone(modifyPhoneStep)"
						>下一步</van-button
					>
				</div>
			</div>
		</div>
		<!-- 去绑定 -->
		<div v-else class="toBind">
			<div class="inputWrapper">
				<van-field v-model="modifyAccount.account" class="inputItem" center clearable :border="false" placeholder="请输入新手机号" />
			</div>
			<div class="inputWrapper authcodeInputWrapper">
				<van-field v-model="modifyAccount.authCode" class="inputItem authcodeInput" center clearable placeholder="请输入验证码" :border="false" />
				<div class="getVerificationStyle fr" @click="postAccountGetAuthCode('newphone')" :style="{ color: Countdown > 0 ? '#BBBBBB' : '#333333' }">
					{{ VerificationStatus }}
				</div>
			</div>
			<div class="OperatingSpace">
				<van-button round type="info" :class="modifyPhoneBtnColor ? 'noneVanButton' : 'van-button--info'" @click="handleBind">确定</van-button>
			</div>
		</div>
	</div>
</template>

<script>
import MD5 from 'js-md5'
import { isPhone } from '../../../utils/validate'
export default {
	name: 'modifyPhone',
	data() {
		return {
			userphone: '',
			Countdown: 0,
			modifyPhoneStep: 1,
			modifyAccount: {
				account: '',
				authCode: '',
			},
			phoneCode: '', //验证身份
		}
	},
	computed: {
		VerificationStatus() {
			if (this.Countdown) {
				return `重新获取 ${this.Countdown}s`
			} else {
				return '发送验证码'
			}
		},
		modifyPhoneBtnColor() {
			//绑定手机号
			if (!this.userphone) {
				if (!this.modifyAccount.account || !this.modifyAccount.authCode) {
					return true
				} else {
					return false
				}
			}
			// 换绑手机号
			if (this.modifyPhoneStep == 1 && !this.phoneCode) {
				return true
			} else if (this.modifyPhoneStep == 2 && (!this.modifyAccount.account || !this.modifyAccount.authCode)) {
				return true
			} else {
				return false
			}
		},
		phoneNumber() {
			return this.$store.state.userInfo.phone
		},
	},
	mounted() {
        // 通过实名认证、人脸识别方式验证修改手机号
        if(sessionStorage.getItem('modifyPhone') == 1){
            this.modifyPhoneStep = 2
        }
		this.userphone = this.$route.query.userphone
	},
	methods: {
		async handleFaceRecognition() {
			await this.postIsRealNameAuthentication()
			if (this.isRealName) {
                // 人脸认证
                let faceidentifylocalUrl = window.location.href;
                localStorage.setItem("faceidentifylocalUrl", faceidentifylocalUrl);
				this.$router.push('/faceidentify')
			} else {
				// 实名认证
                this.$router.push('/idcard')
			}
		},
		postIsRealNameAuthentication(type) {
			return this.$api.faceauth.judgefaceauth({}).then((res) => {
				const m = `${localStorage.getItem('token')}true`
				this.isRealName = res.data === MD5(m)
				// 用户通过实名认证后可修改手机号
				if (type && this.isRealName) {
					this.modifyPhoneStep = 2
				}
			})
		},
		// 更换手机 发送验证码
		async postAccountGetAuthCode(type) {
			let account = type === 'oldphone' ? this.phoneNumber : this.modifyAccount.account
			const data = { account, type: 2 }
			this.modifyAccount.authCode = null
			if (isPhone.test(account)) {
				if (this.Countdown > 0) return
				this.Countdown = 60
				this.setCountdown()
				this.$sensors.track('UM_Click_Verification_Code_Button')
				this.$api.usercenter.getAuthCodePublic({ data })
			} else {
				this.$notify({ type: 'danger', message: '请输入正确的手机号' })
			}
		},
		setCountdown() {
			this.CountdownInterval = setInterval(() => {
				this.Countdown--
				if (this.Countdown <= 0) {
					clearInterval(this.CountdownInterval)
				}
			}, 1000)
		},
		// 更换手机操作
		handleModifyPhone(step) {
			if (step == 1) {
				this.checkAuthCode()
			} else if (step == 2) {
				this.unBindUserAccount('phone')
			}
		},
		// 更换手机号
		unBindUserAccount() {
			if (!this.checkoutPhone()) return
			let params = { ...this.modifyAccount }
			this.$api.usercenter.unBindUserAccount(params).then((res) => {
				if (res.data) {
					this.modifyPhoneStep = 3
					this.getUserInfo() //更新用户信息
				}
			})
		},
		// 验证身份
		checkAuthCode() {
			if (!this.phoneCode) {
				this.$notify({ type: 'danger', message: '验证码不能为空' })
				return
			}
			let result = false
			let data = { account: this.phoneNumber, authCode: this.phoneCode }
			this.$api.usercenter.checkAuthCode(data).then((res) => {
				result = res.data
				if (result) {
					this.modifyPhoneStep = 2
					clearInterval(this.CountdownInterval)
					this.Countdown = 0
				}
			})
		},
		// 绑定手机号
		handleBind() {
			if (!this.checkoutPhone()) return
			let params = { ...this.modifyAccount }
			this.$api.usercenter.bindUserAccount(params).then((res) => {
				if (res.data) {
					this.getUserInfo()
					this.$toast({
						message: '手机号绑定成功',
						onClose: () => {
							this.$router.back()
						},
					})
				}
			})
		},
		getUserInfo() {
			this.$api.usercenter.getAccountUserInfo({}).then((res) => {
				localStorage.setItem('WDuserInfo', JSON.stringify(res.data))
				this.$store.commit('setUserInfo', {
					phone: this.modifyAccount.account,
				})
			})
		},
		checkoutPhone() {
			if (!isPhone.test(this.modifyAccount.account)) {
				this.$notify({ type: 'danger', message: '请输入正确的手机号' })
				return false
			}
			if (!this.modifyAccount.authCode) {
				this.$notify({ type: 'danger', message: '验证码不能为空' })
				return false
			}
			return true
		},
    },
    beforeDestroy(){
        sessionStorage.removeItem('modifyPhone')
    }
}
</script>

<style lang="stylus" scoped>
.progress{
  position relative
  width 528px
  margin 0 auto
  .outer-1,.outer-2,.outer-3{
    position relative
    display inline-block
    // top -40px
    width 80px
    height 80px
    line-height 80px
    text-align center
    background rgba(215, 215, 215, 0.2)
    border-radius 50%
    &.active{
      background rgba(25, 114, 255, 0.2)
      .inner{
        background #1972FF
      }
      .txt{
        color #1972FF
      }
    }
    .inner{
      display inline-block
      width 64px
      height 64px
      background #D7D7D7
      border-radius 50%
      line-height 64px
      text-align center
      color #ffffff
    }
    .txt{
      font-size 28px
      font-family PingFangSC-Regular, PingFang SC
      color #BBBBBB
      line-height 28px
      position absolute
      left 50%
      top 100px
      transform translateX(-50%)
      width 170px
    }
  }
  .outer-2{
    margin 0 144px
    margin-top 40px
    &::before{
      content:''
      display block
      position absolute
      left -120px
      top 50%
      transform translateY(-50%)
      width 96px
      height 2px
      background #3660FF
      border-radius 2px
      opacity 0.1
    }
    &::after{
      content:''
      display block
      position absolute
      right -120px
      top 50%
      transform translateY(-50%)
      width 96px
      height 2px
      background #3660FF
      border-radius 2px
      opacity 0.1
    }
  }
}
.form{
  width 690px
  margin 0 auto
}
.desc{
  width 690px
  padding 40px 0
  box-sizing border-box
  margin 0 auto
  margin-top 80px
  margin-bottom 64px
  border-radius 6px
  background #F5F6FA
  font-size 28px
  font-family PingFangSC-Regular, PingFang SC
  font-weight 400
  color #333333
  text-align center
  .desc1{
    color #202120
    line-height 1
  }
  .desc2 {
      color #666666
      .face {
          color #3660FF
      }
  }
  .desc1{
    margin-bottom 24px
  }
}
.inputWrapper {
  width 622px
  margin 0 auto
  display flex
  align-items center
  height 128px
  border-bottom 1px solid #D7D7D7
  box-sizing border-box
  .inputItem{
    // width 470px
    // display inline-block
    padding 0
    height 58px
    line-height 58px
    font-size 36px
    font-family PingFangSC-Medium, PingFang SC
    font-weight 500
    color #CCCCCC
    background transparent
  }
}
.authcodeInputWrapper{
  justify-content space-between
  .authcodeInput{
    width 430px
    display inline-block
  }
  .getVerificationStyle{
    color #333333
    font-size 30px
    font-family PingFangSC-Regular, PingFang SC
  }
}
.phoneInput{
  margin-top 112px
}
.OperatingSpace{
  width 622px
  position relative
  margin-left -311px
  left 50%
  span{
      color #333333
      font-size 30px
  }
  .van-button{
      width 100%
      height 44px
      line-height 44px
      margin-top 32px
      margin-bottom 24px
      span{
          color #FFFFFF
          font-size 16px
      }
  }
  .noneVanButton{
      background-color #C0D5FF
      border 1px solid #C0D5FF
  }
  .van-button--info{
      background-color linear-gradient(136deg, #227FFF 0%, #316FFF 100%)
      border 1px solid linear-gradient(136deg, #227FFF 0%, #316FFF 100%)
  }
}
.modifySuccess{
  display flex
  align-items center
  flex-direction column
  .img {
      width 400px
      height 396px
      background:url('../../../assets/images/account/genghuanchenggong.png') no-repeat center
      background-size cover
  }
  .success_title{
    font-size 36px
    font-family PingFangSC-Regular, PingFang SC
    color #202124
    line-height 1
  }
  .success_tip{
    margin 32px 0 80px 0
    font-size 28px
    font-family PingFangSC-Regular, PingFang SC
    color #BBBBBB
    line-height 1
  }
  .success_btn{
    width 236px
    height 80px
    font-size 32px
    font-family PingFangSC-Regular, PingFang SC
    color #1972FF
    text-align center
    line-height 80px
    border-radius 44px
    border 1px solid #1972FF
  }
}
.toBind{
  width 622px
  margin 0 auto
}
</style>
